import { useContext } from 'react';

import ApplicationsParent from './ApplicationsParent';
import ScholarshipApplication from './scholarshipApplication';
import AdminDashboard from './adminDashboard';
import ApplicantDashboard from './applicantDashboard';
import { ShipyardContext } from '../Context';
import { userTypes } from '../../utils/enums';

export default function Applications() {
    const { userSettings } = useContext(ShipyardContext);

    const appropriateView = (userType) => {
        switch (userType) {
            //#TODO TechDebt - Eventually deprecated ApplicationsParent for ApplicantDashboard
            case userTypes.Parent:
                return userSettings.ClientOrgId === 7 ? <ApplicantDashboard /> : <ApplicationsParent />;
            //#TODO TechDebt - Eventually deprecate ScholarshipApplication in favor of AdminDashboard when the TableCellType can be genericized.
            case userTypes.ScholarshipOrg:
                return userSettings.ClientOrgId === 7 ? <AdminDashboard /> : <ScholarshipApplication />;
            default:
                return <div>SHIP error 7457</div>;
        }
    };

    return appropriateView(userSettings.UserType);
}
